export enum PromotionIconEnum {
  UP = 'up',
  DOWN = 'down',
  REMAIN = 'remain',
  TROPHY = 'trophy',
  CUP = 'cup',
}
